import React from "react";
import { useTranslation } from "react-i18next";
import { try_for_free } from "../../url";
import RefSiteFooter from "./RefSiteFooter";
import RefPricingTeaser from "./RefPricingTeaser";

// Assets
import rebranding_and_white_labling from "../../Assets/rebranding_and_white_labling.png";
import add_file from "../../Assets/add_file.png";
import template from "../../Assets/template.png";
import links from "../../Assets/links.png";
import textIcon from "../../Assets/text.png";
import signatureIcon from "../../Assets/signature.png";
import initialsIcon from "../../Assets/initials.png";
import dateIcon from "../../Assets/date.png";
import checkmarkIcon from "../../Assets/checkmark.png";
import stampIcon from "../../Assets/stamp.png";
import driving_licenseIcon from "../../Assets/driving_license.png";
import password_photoIcon from "../../Assets/password_photo.png";
import dropdownIcon from "../../Assets/dropdown.png";
import send_document from "../../Assets/send_document.png";
import coming_soon from "../../Assets/coming_soon.png";

const FEATURE_STYLES = `
  @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:ital,wght@0,400;0,500;0,600;0,700;0,800;1,400&display=swap');
  :root {
    --rsf-ink: #163A5A; --rsf-ink2: #3D6A8C; --rsf-ink3: #5E87A3;
    --rsf-sky: #1A63A5; --rsf-mint: #2AB6E8;
    --rsf-secondary: #2AB6E8;
    --rsf-secondary-deep: #1AA3D4;
    --rsf-secondary-soft: #D9F4FC;
    --rsf-secondary-muted: rgba(42,182,232,0.18);
    --rsf-sky-light: #E8F4FC;
    --rsf-sky-hover: #155a94;
    --rsf-bg-dark: #0E2D48;
    --rsf-white: #FFFFFF; --rsf-surface: #F5F9FC;
    --rsf-ff-head: 'Plus Jakarta Sans', system-ui, sans-serif; --rsf-ff-body: 'Plus Jakarta Sans', system-ui, sans-serif;
  }
  .rsf-page { font-family: var(--rsf-ff-body); color: var(--rsf-ink); background: var(--rsf-white); }

  /* HERO */
  .rsf-hero {
    text-align: center; padding: 64px 24px 32px;
    background: linear-gradient(180deg, #E8F4FC 0%, var(--rsf-secondary-soft) 35%, #fff 100%);
    position: relative; overflow: hidden;
  }
  .rsf-hero::before {
    content: ''; position: absolute; top: -150px; left: 50%; transform: translateX(-50%);
    width: 900px; height: 500px;
    background: radial-gradient(ellipse, rgba(26,99,165,.08) 0%, transparent 65%);
    pointer-events: none;
  }
  .rsf-hero-orb {
    position: absolute; width: 400px; height: 400px; border-radius: 50%;
    background: radial-gradient(circle, rgba(42,182,232,0.15) 0%, transparent 60%);
    top: -100px; right: -100px; z-index: 0; filter: blur(20px);
  }
  .rsf-hero-content { position: relative; z-index: 1; max-width: 800px; margin: 0 auto; }
  .rsf-h1 { font-family: var(--rsf-ff-head); font-size: clamp(38px, 6vw, 60px); font-weight: 800; letter-spacing: -.02em; line-height: 1.08; margin-bottom: 16px; }
  .rsf-h1-grad { background: linear-gradient(135deg, var(--rsf-sky), var(--rsf-mint)); -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text; }
  .rsf-hero-sub { font-size: 18px; color: var(--rsf-ink2); font-weight: 400; max-width: 580px; margin: 0 auto 16px; line-height: 1.6; }

  /* SECTIONS */
  .rsf-section { padding: 80px 24px; max-width: 1240px; margin: 0 auto; box-sizing: border-box; }
  .rsf-section-alt { background: var(--rsf-bg-dark); padding: 88px 32px; }
  .rsf-section-alt-inner { max-width: 1240px; margin: 0 auto; }

  /* Dark section overrides */
  .rsf-section-alt .rsf-h2 { color: #fff; }
  .rsf-section-alt .rsf-p { color: rgba(255,255,255,0.7); }
  .rsf-section-alt .rsf-section-label { background: rgba(42,182,232,.15); color: var(--rsf-mint); }

  .rsf-grid { display: grid; grid-template-columns: 1fr 1.15fr; gap: 64px; align-items: center; margin-bottom: 88px; }
  .rsf-grid:last-child { margin-bottom: 0; }
  .rsf-grid.reverse { grid-template-columns: 1.15fr 1fr; direction: rtl; }
  .rsf-grid.reverse > * { direction: ltr; }

  .rsf-text-block { position: relative; z-index: 2; }
  .rsf-section-label { display: inline-block; font-size: 11px; font-weight: 700; color: var(--rsf-sky); background: var(--rsf-sky-light); padding: 4px 10px; border-radius: 6px; letter-spacing: .08em; margin-bottom: 16px; text-transform: uppercase; }
  .rsf-h2 { font-family: var(--rsf-ff-head); font-size: clamp(30px, 4vw, 42px); font-weight: 800; line-height: 1.15; letter-spacing: -.02em; color: var(--rsf-ink); margin-bottom: 20px; }
  .rsf-h2.center { text-align: center; margin-bottom: 48px; }
  .rsf-p { font-size: 16.5px; color: var(--rsf-ink2); line-height: 1.7; margin-bottom: 20px; font-weight: 400; }
  
  .rsf-image-wrap { 
    position: relative; border-radius: 20px; z-index: 1; 
    transition: all 0.25s; border: 1px solid transparent;
  }
  .rsf-image-wrap:hover { 
    transform: translateY(-4px); 
    box-shadow: 0 16px 40px rgba(26,99,165,.1); 
    border-color: rgba(26,99,165,.28); 
  }
  .rsf-img { width: 100%; height: auto; display: block; border-radius: 20px; box-shadow: 0 24px 64px rgba(22,58,90,.12); }

  .rsf-mac-window {
    background: #fff; border-radius: 12px; overflow: hidden;
    box-shadow: 0 12px 32px rgba(22,58,90,.1); border: 1px solid rgba(26,99,165,.15);
    margin-top: 28px;
  }
  .rsf-mac-header { background: #F5F9FC; border-bottom: 1px solid rgba(26,99,165,.1); padding: 12px 16px; display: flex; gap: 6px; }
  .rsf-mac-dot { width: 10px; height: 10px; border-radius: 50%; }
  .rsf-mac-dot.red { background: #FF5F56; }
  .rsf-mac-dot.yellow { background: #FFBD2E; }
  .rsf-mac-dot.green { background: #27C93F; }
  .rsf-mac-body { padding: 20px; text-align: center; }
  .rsf-mac-label { font-size: 12px; color: var(--rsf-ink3); margin-bottom: 8px; font-weight: 600; letter-spacing: .05em; text-transform: uppercase; }
  .rsf-mac-val { font-family: monospace; font-size: 19px; font-weight: 700; color: var(--rsf-sky); }

  /* 3 COL GRID */
  .rsf-3col-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 24px; margin-bottom: 24px; }
  .rsf-3col-card { 
    background: linear-gradient(180deg, #ffffff 0%, var(--rsf-surface) 100%);
    border: 1px solid rgba(26,99,165,.1); border-radius: 20px; padding: 24px;
    text-align: center; transition: all 0.3s cubic-bezier(0.2, 0.8, 0.2, 1); 
  }
  .rsf-3col-card:hover { transform: translateY(-6px); box-shadow: 0 20px 40px rgba(22,58,90,.08); border-color: var(--rsf-secondary-muted); }
  .rsf-3col-img { width: 100%; max-width: 240px; margin: 0 auto 20px; border-radius: 12px; box-shadow: 0 8px 24px rgba(22,58,90,.08); display: block; }
  .rsf-3col-text { font-size: 17px; font-weight: 700; color: var(--rsf-ink); margin-bottom: 8px; }

  /* FUNCTION CARDS */
  .rsf-func-intro {
    max-width: 640px;
    margin-bottom: 24px;
    color: var(--rsf-ink2);
    font-size: 16px;
    line-height: 1.65;
  }
  .rsf-func-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 20px;
    margin-bottom: 72px;
    align-items: stretch;
  }
  .rsf-func-card {
    background: linear-gradient(180deg, #ffffff 0%, #f8fbfe 100%);
    border: 1px solid rgba(26,99,165,.14);
    border-radius: 18px;
    padding: 18px 16px;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 14px;
    transition: transform 0.22s ease, box-shadow 0.22s ease, border-color 0.22s ease;
    box-shadow: 0 8px 22px rgba(22,58,90,0.06);
    text-align: left;
    min-width: 0;
  }
  .rsf-func-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 14px 30px rgba(22,58,90,.12);
    border-color: rgba(26,99,165,.32);
  }
  .rsf-func-icon-wrap {
    width: 54px;
    height: 54px;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }
  .rsf-func-icon { width: 30px; height: 30px; object-fit: contain; }
  .rsf-func-label { font-size: 15.5px; font-weight: 700; color: var(--rsf-ink); }
  .rsf-func-meta {
    margin-top: 3px;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: .04em;
    color: var(--rsf-sky);
    text-transform: uppercase;
  }
  
  .rsf-fi-0 { background: rgba(26,99,165,.1); }
  .rsf-fi-1 { background: rgba(42,182,232,.1); }
  .rsf-fi-2 { background: rgba(96,165,250,.1); }
  .rsf-fi-3 { background: rgba(251,191,36,.1); }
  .rsf-fi-4 { background: rgba(251,146,60,.1); }
  .rsf-fi-5 { background: rgba(45,212,191,.1); }
  .rsf-fi-6 { background: rgba(167,139,250,.1); }
  .rsf-fi-7 { background: rgba(244,114,182,.1); }
  .rsf-fi-8 { background: rgba(52,211,153,.1); }

  /* DEV BANNER */
  .rsf-dev-banner {
    background: linear-gradient(135deg, var(--rsf-sky-light) 0%, var(--rsf-secondary-soft) 100%);
    border-radius: 24px; padding: 48px; border: 1px solid var(--rsf-secondary-muted);
    display: grid; grid-template-columns: 1.2fr 1fr; gap: 48px; align-items: center;
    margin-bottom: 64px; box-shadow: 0 20px 48px rgba(42,182,232,0.1);
  }

  /* BUTTONS */
  .rsf-btn {
    font-family: var(--rsf-ff-body); font-size: 14.5px; font-weight: 600;
    padding: 13px 26px; border-radius: 10px; cursor: pointer;
    transition: all .2s; border: none; text-decoration: none; display: inline-flex; align-items: center;
    white-space: nowrap;
  }
  .rsf-btn-primary { background: linear-gradient(135deg, var(--rsf-sky) 0%, var(--rsf-secondary-deep) 100%); color: #fff; box-shadow: 0 4px 14px rgba(42,182,232,0.35); }
  .rsf-btn-primary:hover { background: linear-gradient(135deg, var(--rsf-sky-hover) 0%, var(--rsf-sky) 100%); transform: translateY(-2px); box-shadow: 0 6px 18px rgba(42,182,232,0.4); }

  @media (max-width: 1024px) {
    .rsf-grid { gap: 48px; grid-template-columns: 1fr; }
    .rsf-grid.reverse { grid-template-columns: 1fr; }
    .rsf-3col-grid { grid-template-columns: repeat(2, 1fr); }
    .rsf-func-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 16px; }
    .rsf-dev-banner { grid-template-columns: 1fr; gap: 36px; padding: 36px 24px; }
  }
  @media (max-width: 600px) {
    .rsf-hero { padding: 48px 20px 32px; }
    .rsf-h1 { font-size: 34px; }
    .rsf-hero-sub { font-size: 15px; }
    .rsf-h2 { font-size: 28px; }
    .rsf-p { font-size: 15px; }
    .rsf-grid { gap: 32px; }
    .rsf-grid.reverse { direction: ltr; }
    .rsf-section, .rsf-section-alt { padding: 48px 20px; }
    .rsf-3col-grid { grid-template-columns: 1fr; }
    .rsf-func-grid { grid-template-columns: 1fr; gap: 12px; }
    .rsf-btn { width: 100%; justify-content: center; box-sizing: border-box; }
  }
`;

function RefFeatures() {
  const { t } = useTranslation('features');

  const uploadFeatures = [
    { src: add_file, text: t('workflow.items.upload.text'), sub: t('workflow.items.upload.sub') },
    { src: template, text: t('workflow.items.assign.text'), sub: t('workflow.items.assign.sub') },
    { src: links, text: t('workflow.items.link.text'), sub: t('workflow.items.link.sub') },
  ];

  const functionalities = [
    { src: textIcon, label: t('functions.items.text.label') },
    { src: signatureIcon, label: t('functions.items.signature.label') },
    { src: initialsIcon, label: t('functions.items.initials.label') },
    { src: dateIcon, label: t('functions.items.date.label') },
    { src: checkmarkIcon, label: t('functions.items.checkmark.label') },
    { src: stampIcon, label: t('functions.items.stamp.label') },
    { src: driving_licenseIcon, label: t('functions.items.license.label') },
    { src: password_photoIcon, label: t('functions.items.passport.label') },
    { src: dropdownIcon, label: t('functions.items.dropdown.label') },
  ];

  return (
    <div className="rsf-page">
      <style>{FEATURE_STYLES}</style>

      {/* HERO */}
      <div className="rsf-hero">
        <div className="rsf-hero-orb" />

        <div className="rsf-hero-content">
          <h1 className="rsf-h1">
            {t('hero.titlePrefix')}<span className="rsf-h1-grad">{t('hero.titleHighlight')}</span>
          </h1>
          <p className="rsf-hero-sub">
            {t('hero.subtitle')}
          </p>
        </div>
      </div>

      {/* MAIN CONTENT */}
      <div className="rsf-section">
        <div className="rsf-grid reverse">
          <div className="rsf-image-wrap">
            <img
              src={rebranding_and_white_labling}
              alt="Rebranding & White Labeling"
              className="rsf-img"
            />
          </div>
          <div className="rsf-text-block">
            <div className="rsf-section-label">{t('customization.label')}</div>
            <h2 className="rsf-h2">
              {t('customization.titleLine1')}<br />
              {t('customization.titleLine2')}
            </h2>
            <p className="rsf-p">
              {t('customization.description')}
            </p>
            <div className="rsf-mac-window">
              <div className="rsf-mac-header">
                <div className="rsf-mac-dot red" />
                <div className="rsf-mac-dot yellow" />
                <div className="rsf-mac-dot green" />
              </div>
              <div className="rsf-mac-body">
                <div className="rsf-mac-label">{t('customization.customDomainLabel')}</div>
                <div className="rsf-mac-val">{t('customization.customDomainVal')}</div>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "16px",
                marginTop: "32px",
              }}
            >
              <a
                href={try_for_free}
                target="_blank"
                rel="noreferrer"
                className="rsf-btn rsf-btn-primary"
                style={{ marginTop: 0 }}
              >
                {t('customization.tryFree')}
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* UPLOADING & FORMATTING */}
      <div className="rsf-section-alt">
        <div className="rsf-section-alt-inner">
          <div className="rsf-section-label">{t('workflow.label')}</div>
          <h2 className="rsf-h2 center">{t('workflow.title')}</h2>

          <div className="rsf-3col-grid">
            {uploadFeatures.map((feature, i) => (
              <div key={i} className="rsf-3col-card">
                <img
                  src={feature.src}
                  alt={feature.text}
                  className="rsf-3col-img"
                />
                <div className="rsf-3col-text">{feature.text}</div>
                <p
                  className="rsf-p"
                  style={{
                    fontSize: "14px",
                    marginTop: "12px",
                    color: "var(--rsf-ink2)",
                  }}
                >
                  {feature.sub}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* FUNCTIONS */}
      <div className="rsf-section">
        <div className="rsf-section-label">{t('functions.label')}</div>
        <h2 className="rsf-h2">{t('functions.title')}</h2>
        <p className="rsf-func-intro">
          {t('functions.intro')}
        </p>

        <div className="rsf-func-grid">
          {functionalities.map(({ src, label }, i) => (
            <div className="rsf-func-card" key={i}>
              <div className={`rsf-func-icon-wrap rsf-fi-${i % 9}`}>
                <img src={src} alt={label} className="rsf-func-icon" />
              </div>
              <div>
                <div className="rsf-func-label">{label}</div>
                <div className="rsf-func-meta">{t('functions.fieldMeta')}</div>
              </div>
            </div>
          ))}
        </div>

        <div className="rsf-image-wrap" style={{ marginBottom: "96px" }}>
          <img
            src={send_document}
            alt="Document Process"
            className="rsf-img"
            style={{ boxShadow: "0 24px 64px rgba(22,58,90,.2)" }}
          />
        </div>

        <div className="rsf-dev-banner">
          <div className="rsf-text-block">
            <div
              className="rsf-section-label"
              style={{
                background: "rgba(42,182,232,0.2)",
                color: "var(--rsf-sky-hover)",
              }}
            >
              {t('api.label')}
            </div>
            <h2 className="rsf-h2">{t('api.title')}</h2>
            <p
              className="rsf-p"
              style={{ color: "var(--rsf-ink)", fontSize: "17.5px" }}
            >
              {t('api.prefix')}
              <strong style={{ color: "var(--rsf-sky)" }}>{t('api.developers')}</strong>
              {t('api.and')}
              <strong style={{ color: "var(--rsf-sky)" }}>{t('api.companies')}</strong>
              {t('api.suffix')}
            </p>
            <div
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "8px",
                background: "#fff",
                color: "var(--rsf-sky)",
                fontWeight: 700,
                padding: "10px 20px",
                borderRadius: "100px",
                marginTop: "16px",
                fontSize: "13px",
                letterSpacing: "0.05em",
                boxShadow: "0 4px 12px rgba(26,99,165,0.1)",
                border: "1px solid rgba(26,99,165,0.15)",
              }}
            >
              <span className="rsf-eyebrow-dot" /> {t('api.comingSoon')}
            </div>
          </div>
          <div className="rsf-image-wrap" style={{ border: "none" }}>
            <img
              src={coming_soon}
              alt="Coming Soon"
              className="rsf-img"
              style={{ boxShadow: "none" }}
            />
          </div>
        </div>
      </div>

      {/* PRICING TEASER */}
      <RefPricingTeaser />

      {/* FOOTER */}
      <RefSiteFooter />
    </div>
  );
}

export default RefFeatures;
